import React from 'react'

import styled, { keyframes } from 'styled-components'

type TSpinnerProps = {
  centerHorizontally?: boolean
  centerVertically?: boolean
  fillWidth?: boolean
  containerHeight?: string
  containerWidth?: string
  show?: boolean
  marginTop?: string
  marginBottom?: string
  marginRight?: string
  marginLeft?: string
  containerStyle?: { [attr: string]: string }
  size?: string
  color?: string
  width?: number
}

const spinAnimation = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const SpinnerContainer = styled.div<Omit<TSpinnerProps, 'size'>>`
  flex-direction: column;

  ${props => {
    const {
      show,
      centerHorizontally,
      centerVertically,
      fillWidth,
      containerHeight: height,
      containerWidth: width,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
    } = props

    return `
      display: ${show ? 'flex' : 'none'};
      ${width ? `width: ${width};` : ''}
      ${height ? `height: ${height};` : ''}
      ${fillWidth ? 'width: 100%;' : ''}
      ${centerHorizontally ? 'align-items: center;' : ''}
      ${centerVertically ? 'justify-content: center;' : ''}
      ${marginTop ? `margin-top: ${marginTop};` : ''}
      ${marginBottom ? `margin-bottom: ${marginBottom};` : ''}
      ${marginLeft ? `margin-left: ${marginLeft};` : ''}
      ${marginRight ? `margin-right: ${marginRight};` : ''}
    `
  }}
`

export const SpinnerWheel = styled.div<{
  size: string
  color?: string
  width?: number
}>`
  background-color: transparent;
  display: inline-block;
  width: ${props => props.size};
  height: ${props => props.size};
  border: ${({ width = 5 }) => width}px solid #f6f7fa;
  border-radius: 50%;
  border-top-color: ${({ color = '#ed008b' }) => color};
  animation: ${spinAnimation} 1s ease-in-out infinite;
`

export const Spinner: React.FC<TSpinnerProps> = ({
  centerHorizontally = true,
  centerVertically = true,
  fillWidth = true,
  show = true,
  containerStyle,
  size = '50px',
  color,
  width,
  ...props
}) => (
  <SpinnerContainer
    show={show}
    centerHorizontally={centerHorizontally}
    centerVertically={centerVertically}
    fillWidth={fillWidth}
    style={containerStyle}
    {...props}
  >
    <SpinnerWheel width={width} color={color} size={size} />
  </SpinnerContainer>
)
